import React from 'react';
import castArray from 'lodash/castArray';
import Overlay from '../ScreenOverlay';

type Props = {
  show: boolean;
  children: any;
  classList: any | any[];
  onClick: any;
} & any;

const ModalWithOverlay = ({ show, children, classList, ...props }: Props) => (
  <Overlay zIndex={11} show={show} classList={castArray(classList)} {...props}>
    {children}
  </Overlay>
);

ModalWithOverlay.defaultProps = {
  classList: []
};

export default ModalWithOverlay;
